export default "__VITE_ASSET__DAAD_zzr__"